<template>
    <div>
        <ul v-if="products" ref="list" :class="innerListClass" @scroll="$emit('scroll', $event)">
            <li id="creator" class="lazy-hover product-list-item font-roboto-c">
                <div class="frame creator-frame overflow-hidden">
                    <div v-if="partner.partner_type_id === 2">
                        <img
                            v-if="partner.avatar"
                            :src="`${$scope.CDN_IMAGES}/images/site/parceiros/avatars/${partner.avatar}?auto=compress,format&q=65`"
                            alt="Avatar do parceiro"
                            class="lazy artist-avatar mb"
                        />
                        <img
                            v-else
                            :src="`${$scope.CDN_IMAGES}/images/site/parceiros/avatars/selo_artista_padrao.svg?auto=compress,format&q=65`"
                            alt="Selo artista convidado"
                            class="lazy artist-avatar mb"
                        />
                        <div class="hidden-xs-down creator-text">
                            <p>
                                <strong>{{ partner.name }}, </strong>
                                <span v-if="partner.gender === 1">
                                    é um dos artistas participantes do nosso projeto
                                </span>
                                <span v-else-if="partner.gender === 2">
                                    é uma das artistas participantes do nosso projeto
                                </span>
                                <span v-else> artista participante do nosso projeto </span>
                                <strong> Galeria de Artistas</strong>.
                            </p>
                            <p>
                                Confira outras artes
                                <span v-if="partner.gender === 1"> dele </span>
                                <span v-else-if="partner.gender === 2"> dela </span>
                                <span v-else> delx </span>
                                que estão disponíveis em produtos da Chico Rei.
                            </p>
                            <a
                                class="btn btn-default mt-3"
                                :href="`/artistas/${partner.url}`"
                                target="_blank"
                                >Ver catálogo</a
                            >
                        </div>
                        <div class="hidden-xs-up creator-text">
                            <p>
                                Confira outras artes de
                                <strong>{{ partner.name }}, </strong>
                                participante do projeto
                                <strong> Galeria de Artistas</strong>.
                            </p>
                            <a
                                class="btn btn-sm btn-default mt-3"
                                :href="`/artistas/${partner.url}`"
                                target="_blank"
                                >Ver catálogo</a
                            >
                        </div>
                    </div>
                    <div v-else-if="partner.partner_type_id === 1">
                        <img
                            v-if="partner.logo_image"
                            :src="`${$scope.CDN_IMAGES}/images/site/parceiros/logos/${partner.logo_image}?auto=compress,format&q=65`"
                            alt="Logo do parceiro"
                            class="lazy artist-logo mb"
                        />
                        <img
                            v-else
                            :src="`${$scope.CDN_IMAGES}/images/site/parceiros/logos/colecao-oficial-selo-padrao.png?auto=compress,format&q=65`"
                            alt="Selo coleção oficial Chico Rei"
                            class="lazy artist-logo mb"
                        />
                        <p>
                            Esta peça faz parte da coleção oficial
                            <strong>{{ partner.name }}</strong> com a Chico Rei!
                        </p>
                        <p>Confira outros produtos desta coleção.</p>
                        <a class="btn btn-default mt-3" :href="`/${partner.url}`" target="_blank"
                            >Ver catálogo</a
                        >
                    </div>
                    <div v-else>
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/site/parceiros/avatar/selo_CREstudio_laranja.png?auto=compress,format&q=65`"
                            alt="Selo estúdio Chico Rei"
                            class="lazy artist-logo mb"
                        />
                        <p>Esta peça é uma criação original de nossos artistas.</p>
                        <p>Confira outros produtos autorais.</p>
                        <a class="btn btn-default mt-3" :href="`/camiseta/estudio`" target="_blank"
                            >Ver catálogo</a
                        >
                    </div>
                </div>
            </li>
            <ProductListItem
                v-for="product in limitedProducts"
                :small="small"
                :key="`${product.id}-${gender}`"
                :options="innerItemOptions"
                :product="product"
                :selected-filters="selectedFilters"
                :shorter-image="shorterImage"
                @click="pushItemEvent(product)"
            >
                <template v-slot:below-image>
                    <slot name="below-image" :product="product" />
                </template>
            </ProductListItem>
        </ul>
    </div>
</template>

<script>
    import ProductListItem from '../product/ProductListItem';
    import { updateLazyLoad } from '../../../common/lazyload';

    const DEFAULT_ITEM_OPTIONS = {
        baseUrl: window.url,
        displayName: true,
        displayArt: true,
        displayPrice: true,
        displayColors: false,
        imageWidth: 290,
        imageHeight: 435,
        lang: 'pt',
    };

    export default {
        name: 'ProductCreatorOtherProductsList',

        components: { ProductListItem },

        props: {
            products: {
                type: Array,
                required: true,
            },
            itemOptions: {
                type: Object,
                default: () => DEFAULT_ITEM_OPTIONS,
            },
            sliderOptions: {
                type: Object,
            },
            selectedFilters: {
                type: Object,
            },
            eventName: String,
            currentPage: {
                type: Number,
                default: 0,
            },
            perPage: {
                type: Number,
                default: 0,
            },
            gender: {
                type: Number,
                default: 0,
            },
            listClass: {
                type: String | Object,
                default: 'product-list product-list-4 product-list-gap-y-4',
            },
            shorterImage: Boolean,
            small: Boolean,
            partner: {
                type: Object,
            },
        },

        data() {
            return {
                productsLayer: null,
            };
        },

        watch: {
            products: {
                immediate: true,
                handler(to) {
                    if (!to) return;
                    this.pushListEvent();
                    this.$nextTick(() => {
                        updateLazyLoad();
                    });
                },
            },
        },

        computed: {
            limitedProducts() {
                return (this.options || {}).limit > 0
                    ? this.products.slice(
                          this.options.offset,
                          this.options.offset + this.options.limit
                      )
                    : this.products;
            },

            innerListClass() {
                let classes = { slider: this.sliderOptions };

                if (typeof this.listClass === 'string') {
                    classes[this.listClass] = true;
                } else {
                    classes = { ...classes, ...this.listClass };
                }
                return classes;
            },

            innerItemOptions() {
                const inner = { ...this.itemOptions };

                for (let prop in DEFAULT_ITEM_OPTIONS) {
                    if (DEFAULT_ITEM_OPTIONS.hasOwnProperty(prop) && inner[prop] === undefined) {
                        inner[prop] = DEFAULT_ITEM_OPTIONS[prop];
                    }
                }

                return inner;
            },
        },

        methods: {
            pushListEvent() {
                if (!this.eventName) return;

                window.dataLayer = window.dataLayer || [];

                this.productsLayer = this.products.map((product, index) => {
                    return {
                        name: product.name,
                        id: product.id + '',
                        price: product.price + '',
                        brand: 'Chico Rei',
                        category: product.type.name,
                        variant: '',
                        list: this.eventName,
                        position: this.perPage * (this.currentPage - 1) + index,
                    };
                });

                window.dataLayer.push({
                    event: 'list-products',
                    non_interaction: true,
                    ecommerce: {
                        currencyCode: 'BRL',
                        impressions: this.productsLayer,
                    },
                });
            },

            pushItemEvent(product) {
                if (!this.eventName) return;
                window.dataLayer.push({
                    event: 'productClick',
                    ecommerce: {
                        click: {
                            actionField: { list: this.eventName },
                            products: [
                                this.productsLayer.find((item) => item.id === product.id + ''),
                            ],
                        },
                    },
                });
            },
        },
    };
</script>
